import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b212386a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container d-flex justify-content-center align-items-center flex-column" }
const _hoisted_2 = { class: "title my-5 text-break text-center" }
const _hoisted_3 = {
  key: 0,
  class: "description mb-3"
}
const _hoisted_4 = {
  key: 1,
  class: "description mb-3"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { useStore } from 'vuex'
import { USER_STORE } from '@/store/constants'
import { useRouter, useRoute } from 'vue-router'
import { watchEffect, computed, onMounted, ref } from 'vue'
import { PATH } from '@/constants'
import { getCookie } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()
const success = localStorage.getItem('checkSubmit')
const first_time = ref()

onMounted(() => {
  const path = PATH[`${route.path.split('/')[1]}`]

  if (getCookie(path.header) && getCookie(path?.pathName)) {
    first_time.value = false
  } else {
    first_time.value = true
  }
})

watchEffect(() => {
  if (!success) {
    router.push('/community/join_users')
  }
})
const invitedCommunity = computed(() => store.getters[USER_STORE.GETTERS.INVITE_COMMUNITY])

const redirectLogin = () => {
  router.push('/community/users/login')
  localStorage.removeItem('checkSubmit')
}

const redirectTop = () => {
  router.push('/community/lobby')
  localStorage.removeItem('checkSubmit')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(invitedCommunity)?.community_name) + _toDisplayString(first_time.value ? _unref(translate)('SB22title') : _unref(translate)('SB22title2')), 1),
    (first_time.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", null, _toDisplayString(_unref(translate)('SB22description')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(translate)('SB22description3')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(_unref(translate)('SB22description2')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(translate)('SB22description4')), 1)
        ])),
    (first_time.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(Button, {
            title: _unref(translate)('titleButtonLogin'),
            type: 'secondary',
            onClick: redirectLogin
          }, null, 8, ["title"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(Button, {
            title: _unref(translate)('SB22Top'),
            type: 'secondary',
            onClick: redirectTop
          }, null, 8, ["title"])
        ]))
  ]))
}
}

})